import { Link } from "react-router-dom";
import { Check } from "lucide-react";

function Option({ id, active, title, sub, onClick }) {
  return (
    <button type="button" role="radio" aria-checked={active} data-testid={`export-mix-${id}`} onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-2xl border px-3.5 py-2.5 text-left transition-colors duration-150 ${active ? "border-amber-300/50 bg-amber-300/10" : "border-white/10 bg-black/25 hover:bg-white/[0.05]"}`}>
      <span className={`grid h-5 w-5 flex-shrink-0 place-items-center rounded-full border ${active ? "border-amber-200 bg-amber-300 text-black" : "border-white/25"}`}>{active ? <Check className="h-3 w-3" /> : null}</span>
      <span className="min-w-0"><span className="block truncate text-[13px] font-medium">{title}</span><span className="block truncate text-[11px] text-white/45">{sub}</span></span>
    </button>
  );
}

/** Which full mix goes in the pack: the song as it is, or a numbered Mix Desk mix. */
export default function MixSourcePicker({ mixes, value, onChange, songId }) {
  return (
    <div>
      <h3 className="mb-2 font-display text-[15px] font-semibold">Full mix</h3>
      <div role="radiogroup" aria-label="Full mix" className="space-y-1.5">
        {mixes.map((m) => (
          <Option key={m.id} id={m.id} active={value === m.id} onClick={() => onChange(m.id)} title={`Mix ${m.number} · ${m.label}`}
            sub={`From the Mix Desk${m.lufs != null ? ` · ${m.lufs} LUFS` : ""}${m.sample_rate === 48000 ? " · made at 48 kHz" : " · made at 44.1 kHz, converted to 48 kHz"}`} />
        ))}
        <Option id="song" active={value === "song"} onClick={() => onChange("song")} title="The song as it is" sub="The song's own audio, converted to 48 kHz" />
      </div>
      {!mixes.length ? (
        <p className="mt-2 text-[11px] text-white/45">Want it mixed and mastered first? <Link to={`/create/song/${songId}/mix`} data-testid="export-open-mixdesk" className="text-amber-200 underline-offset-2 hover:underline">Open the Mix Desk</Link></p>
      ) : null}
    </div>
  );
}
